import Model  from '@/utils/v01/ActiveModel';

export default class Node extends Model { 
    static backend = '/master/node/';   
    
    static entity = 'node';    
    
    static fields () {
        return {
            id: this.attr(null),
            parent_id: this.attr(null),
            level: this.attr(null),
            name: this.attr(''),
            parent_name: this.attr(''),
            fullname: this.attr(''),
            kodepos: this.attr(null),
            geom: this.attr(null),
            compare_id: this.attr(''),
            levelText: this.attr(''),
            lembar: this.attr(null),
            lembarDone: this.attr(null),
        }
    }

    static propinsis(params={}){
        return this.api.get(this.backend+'propinsi', params).then(res => {          
            return res.status == 200 ? res.data : [];
        });
    }    
}

